import type { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import type { InputDriver } from '../Input/Input.driver';
import type { DropdownLayoutDriver } from '../DropdownLayout/DropdownLayout.driver';

export interface InputWithOptionsDriver extends BaseDriver {
  inputDriver: InputDriver;
  dropdownLayoutDriver: DropdownLayoutDriver;
  driver: {
    exists: () => boolean;
    selectOptionById: (id: string | number) => void;
    isReadOnly: () => boolean;
    isEditable: () => boolean;
    isDisabled: () => boolean;
    inputWrapper: () => HTMLElement;
    focus: () => void;
    blur: () => void;
    pressKey: (key: string) => void;
    outsideClick: () => void;
  };
}
